import { SelectOption } from '../types';
import { V2AreaTreePostResponse } from '@maxtropy/device-customer-apis-v2';

interface AreaTreeNode {
  id?: number;
  zoneName?: string;
  gasSupplyPipeline?: string;
  used?: boolean;
  children?: AreaTreeNode[];
}

interface TreeSelectOption extends SelectOption {
  key: string | number;
  title: string;
  disabled?: boolean;
  children?: TreeSelectOption[];
}

const toAreaTreeOptionsWithDisabled = (
  list: V2AreaTreePostResponse['list'] = [],
  disabledUsed: boolean
): TreeSelectOption[] =>
  (list as AreaTreeNode[]).flatMap(item => {
    const children = toAreaTreeOptionsWithDisabled(item.children, disabledUsed);
    if (item.id === undefined || !item.zoneName) return children;

    return [
      {
        key: item.id,
        value: item.id,
        label: item.zoneName,
        title: item.zoneName,
        disabled: disabledUsed ? item.used : false,
        areaId: item.id,
        children: children.length ? children : undefined,
      },
    ];
  });

export const toAreaTreeOptions = (list: V2AreaTreePostResponse['list'] = []): TreeSelectOption[] =>
  toAreaTreeOptionsWithDisabled(list, true);

export const toGasSourceTreeOptions = (list: V2AreaTreePostResponse['list'] = []): TreeSelectOption[] =>
  toAreaTreeOptionsWithDisabled(list, false);

export const toCircuitOptions = (list: Array<{ name?: string; code?: string }> = []): SelectOption[] =>
  list.map(item => ({
    label: [item.name, item.code].filter(Boolean).join('/'),
    value: item.code ?? item.name ?? '',
    circuitName: item.name,
    circuitCode: item.code,
  }));

export const toDeviceOptions = (list: Array<{ id?: number; name?: string; code?: string }> = []): SelectOption[] =>
  list.map(item => ({
    label: [item.name, item.code].filter(Boolean).join('/') || String(item.id),
    value: item.id ?? '',
  }));

export const toDeviceNameOptions = (
  list: Array<{ id?: number; name?: string; code?: string; used?: boolean }> = []
): SelectOption[] =>
  list
    ?.filter(l => !l.used)
    .map(item => ({
      label: [item.name, item.code].filter(Boolean).join('/') || String(item.id),
      value: item.name ?? '',
      deviceId: item.id,
      deviceName: item.name,
      deviceCode: item.code,
    }));

export const toNameOptions = (list: string[] = []): SelectOption[] => list.map(item => ({ label: item, value: item }));
